import { ReactComponent as CloseIcon } from "assets/images/header/closes.svg";
import { ReactComponent as BurgerIcon } from "assets/images/header/dots.svg";
import { ReactComponent as HeaderLogo } from "assets/images/header/logo.svg";
import { ReactComponent as LoginIcon } from "assets/images/header/navBar/loginIcon.svg";
import Locales from "components/Header/Locales";
import routes from "config/routes";
import { useMainContext } from "context";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Logo = ({ isOpen, open }) => {
  const { t } = useTranslation();
  const { isLoggedIn, userLoading } = useMainContext();
  return (
    <div className="flex items-center justify-between w-full lg:w-auto lg:gap-12 xl:gap-16">
      {/* Left side: Logo & Title */}
      <Link to={routes.home} className="flex items-center gap-2 md:gap-3 hover:opacity-90 transition-opacity">
        <HeaderLogo className="w-8 h-8 md:w-10 md:h-10 shrink-0 text-emerald-500" />
        <h2 className="font-semibold text-gray-800 text-[10px] md:text-[12px] leading-tight max-w-[200px] md:max-w-[260px]">
          {t("General.websiteName")}
        </h2>
      </Link>

      {/* Right side for mobile: Locales + Burger Menu */}
      <div className="flex items-center gap-3 ml-auto lg:ml-8">
        <div className="lg:hidden flex items-center gap-3">
          <Locales />
          {!isLoggedIn && !userLoading && (
            <Link
              to={routes.login}
              className="flex items-center gap-2 bg-[#7ac595] text-white px-4 py-1.5 rounded-full text-[13px] font-semibold hover:bg-[#6ab384] transition-all whitespace-nowrap shadow-sm active:scale-95"
            >
              <LoginIcon className="w-3 h-4 stroke-white" />
              {t("Header.navBar.login")}
            </Link>
          )}
        </div>
        <button
          className="lg:hidden p-2 text-gray-800 hover:text-emerald-500 transition-colors focus:outline-none"
          onClick={isOpen}
          aria-label="Toggle navigation"
        >
          {open ? (
            <CloseIcon className="w-6 h-6 fill-current" />
          ) : (
            <BurgerIcon className="w-6 h-6 fill-current" />
          )}
        </button>
      </div>
    </div>
  );
};

export default Logo;
